import React, { useState } from "react";
import { states } from "../common/IndianStates";
import { Form } from "react-bootstrap";
import { droneDistributor } from "../../services/FormServies";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormConfirmPopUp from "../common/FormConfirmPopUp";
import Modal from "react-modal"; // Import react-modal

// Ensure accessibility
Modal.setAppElement('#root');

const EnterpriseNeedMoreInfo = () => {
  const [popUp, setPopUp] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open state

  const [formState, setFormState] = useState({
    fullName: "",
    emailAddress: "",
    phoneNumber: "",
    alternativePhoneNumber: "",
    state: "",
    city: "",
    identification: "",
    previousExperience: "",
    previousCompanies: "",
    currentCompanies: "",
    sectorInvolvement: "",
    yearsOfExperience: "",
    showroom: "",
    engagementType: "",
    businessAddress: "",
    anyLink: "",
    message: "",
    communicationConsent: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phoneNumber" || name === "alternativePhoneNumber") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormState((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formState.fullName) newErrors.fullName = "Full Name is required";
    if (!formState.emailAddress) newErrors.emailAddress = "Email Address is required";
    if (!formState.phoneNumber || formState.phoneNumber.length !== 10) {
      newErrors.phoneNumber = "Phone Number must be 10 digits";
    }
    if (!formState.state) newErrors.state = "State is required";
    if (!formState.city) newErrors.city = "City is required";
    if (!formState.identification) newErrors.identification = "Identification is required";
    if (!formState.previousExperience) newErrors.previousExperience = "Previous Experience is required";
    if (!formState.sectorInvolvement) newErrors.sectorInvolvement = "Sector Involvement is required";
    if (!formState.yearsOfExperience) newErrors.yearsOfExperience = "Years of Experience is required";
    if (!formState.showroom) newErrors.showroom = "Showroom is required";
    if (!formState.engagementType) newErrors.engagementType = "Engagement Type is required";
    if (!formState.communicationConsent) newErrors.communicationConsent = "Consent is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      droneDistributor(formState).then((res) => {
        if (res?.status === "success") {
          setPopUp(true);
          setFormState({
            fullName: "",
            emailAddress: "",
            phoneNumber: "",
            alternativePhoneNumber: "",
            state: "",
            city: "",
            identification: "",
            previousExperience: "",
            previousCompanies: "",
            currentCompanies: "",
            sectorInvolvement: "",
            yearsOfExperience: "",
            showroom: "",
            engagementType: "",
            businessAddress: "",
            anyLink: "",
            message: "",
            communicationConsent: false,
          });
          closeModal(); // Close the modal after successful submission
        } else {
          toast.error(res?.message);
        }
      });
    } else {
      toast.error("Please fill in all required fields.");
    }
  };

  // Modal Open and Close handlers
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="pb-5">
      {popUp ? (
        <FormConfirmPopUp
          setPopUp={setPopUp}
          para="Thank you for submitting your data. We have received your information and will connect with you shortly."
        />
      ) : null}
      {/* <ToastContainer /> */}

      {/* Button to Open the Modal */}
      <button onClick={openModal} className="bg-darkblue border-0 rounded-2 fs_20 fw-semibold text-white px-4 py-2">
        Apply Now (Open Form)
      </button>

      {/* Modal Component */}
      <Modal
       isOpen={isModalOpen}
  onRequestClose={closeModal}
  contentLabel="Enterprise Form"
  className="modal-content"
  overlayClassName="modal-overlay"
  style={{
    content: {
      top: '100px', // Adjust this value to control the space from the top (header height)
      left: '50%',
      transform: 'translateX(-50%)', // Center the modal horizontally
      width: '80%', // Adjust width as needed
      maxWidth: '800px', // Max width to avoid it being too wide on larger screens
      padding: '30px', // Padding for the modal content
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Darken the background
    },
  }}
>
        <div className="container">
          <div className="bg-white p-md-5 p-4 rounded-4">
            <h4 className="fs_26 fw-bold ff_inter color_blue">Need More Info?</h4>
            <div className="row">
              {Object.entries({
                fullName: "Full Name*",
                emailAddress: "Email Address*",
                phoneNumber: "Phone Number*",
                alternativePhoneNumber: "Alternative Phone Number",
                city: "City*",
                previousCompanies: "Previous Companies",
                currentCompanies: "Current Companies",
                businessAddress: "Business Address",
                anyLink: "Any Link*",
              }).map(([key, label], index) => (
                <div key={index} className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                  <label className="fs_16 ff_inter fw-medium color_darkgray" htmlFor={key}>
                    {label.includes('*') ? (
                      <>
                        {label.replace('*', '')}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ) : (
                      label
                    )}
                  </label>
                  <input
                    className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                    type="text"
                    id={key}
                    name={key}
                    value={formState[key]}
                    onChange={handleChange}
                    maxLength={key === "phoneNumber" || key === "alternativePhoneNumber" ? 10 : undefined}
                  />
                  {errors[key] && <span className="text-danger">{errors[key]}</span>}
                </div>
              ))}

              {/* State selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  State<span style={{ color: "red" }}>*</span>
                </label>
                <Form.Select
                  name="state"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.state}
                  onChange={handleChange}
                >
                  <option value="">Select State</option>
                  {states.map((value, index) => (
                    <option key={index} value={value}>
                      {value}
                    </option>
                  ))}
                </Form.Select>
                {errors.state && <span className="text-danger">{errors.state}</span>}
              </div>

              {/* Identification selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Choose from the following how you would identify yourself or your business currently.
                </label>
                <Form.Select
                  name="identification"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.identification}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Dealer">Dealer</option>
                  <option value="Distributor">Distributor</option>
                  <option value="Super Distributor">Super Distributor</option>
                  <option value="Channel partner/consultant">Channel partner/consultant</option>
                  <option value="Custom hiring center">Custom hiring center</option>
                  <option value="FPO/FPC/farmer association/cooperative society">
                    FPO/FPC/farmer association/cooperative society
                  </option>
                  <option value="Agri/rural/village level entrepreneur">
                    Agri/rural/village level entrepreneur
                  </option>
                  <option value="Others">Others</option>
                </Form.Select>
                {errors.identification && <span className="text-danger">{errors.identification}</span>}
              </div>

              {/* Previous Experience selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Do you have Previous experience as a Dealer with any Company/organization/company
                </label>
                <Form.Select
                  name="previousExperience"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.previousExperience}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
                {errors.previousExperience && <span className="text-danger">{errors.previousExperience}</span>}
              </div>

              {/* Sector Involvement selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Choose the sector in which you/your company have been involved in the past
                </label>
                <Form.Select
                  name="sectorInvolvement"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.sectorInvolvement}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Trackers">Trackers</option>
                  <option value="Farm equipment">Farm equipment</option>
                  <option value="Chemicals & Fertilizers">Chemicals & Fertilizers</option>
                  <option value="Pesticides">Pesticides</option>
                  <option value="Automobiles">Automobiles</option>
                  <option value="Phones & electronic garments">Phones & electronic garments</option>
                  <option value="FMCG products">FMCG products</option>
                  <option value="Consumer Goods">Consumer Goods</option>
                  <option value="Food grains/wholesale">Food grains/wholesale</option>
                  <option value="Other">Other</option>
                </Form.Select>
                {errors.sectorInvolvement && <span className="text-danger">{errors.sectorInvolvement}</span>}
              </div>

              {/* Years of Experience selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray mb-lg-2">
                  No. Of Years of experience in this industry
                </label>
                <Form.Select
                  name="yearsOfExperience"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-lg-4"
                  value={formState.yearsOfExperience}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="0-5 years">0-5 years</option>
                  <option value="5-10 years">5-10 years</option>
                  <option value="10-20 years">10-20 years</option>
                  <option value="Above 20 years">Above 20 years</option>
                </Form.Select>
                {errors.yearsOfExperience && <span className="text-danger">{errors.yearsOfExperience}</span>}
              </div>

              {/* Showroom selection */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Do you have a showroom from which you can display and sell our drones?
                </label>
                <Form.Select
                  name="showroom"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.showroom}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
                {errors.showroom && <span className="text-danger">{errors.showroom}</span>}
              </div>

              {/* Engagement Type selection */}
              <div className="col-sm-6 mt-lg-5 mt-5 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Choose your Engagement
                </label>
                <Form.Select
                  name="engagementType"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formState.engagementType}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="District Dealership">District Dealership</option>
                  <option value="State Distributorship">State Distributorship</option>
                  <option value="Zonal Distributer">Zonal Distributer</option>
                  <option value="National Super Distributer">National Super Distributer</option>
                  <option value="Channel Partner, Consultant & Per Drone Commission Basis">
                    Channel Partner, Consultant & Per Drone Commission Basis
                  </option>
                </Form.Select>
                {errors.engagementType && <span className="text-danger">{errors.engagementType}</span>}
              </div>
            </div>

            {/* Message input */}
            <div className="w-100 mt-lg-4 mt-3 d-flex flex-column">
              <label className="fs_16 ff_inter fw-medium color_darkgray" htmlFor="message">
                Message
              </label>
              <textarea
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                name="message"
                id="message"
                rows={7}
                value={formState.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && <span className="text-danger">{errors.message}</span>}
            </div>

            <p className="fs_16 ff_helvetica fw_400 mt-4">
              By clicking submit below, you consent to allow Drone Plane to store
              and process the personal information submitted above to provide you
              the content requested.
            </p>
            
            {/* Consent checkbox */}
            <div className="d-flex gap-2 align-items-center">
              <input
                type="checkbox"
                id="communicationConsent"
                name="communicationConsent"
                checked={formState.communicationConsent}
                onChange={handleChange}
              />
              <label
                className="fs_16 cursor_pointer fw-normal ff_inter color_darkgray"
                htmlFor="communicationConsent"
              >
                I agree to receive other communications from Drone Plane.<span style={{ color: "red" }}>*</span>
              </label>
              {errors.communicationConsent && (
                <span className="text-danger">{errors.communicationConsent}</span>
              )}
            </div>

            <p className="fs_16 ff_helvetica fw_400 mt-3 mb-0">
              You may unsubscribe at any time. For more information, please see
              the full Drone Plane privacy policy. By clicking submit below, you
              consent to allow Drone Plane to store and process the personal
              information submitted above to provide you the content requested.
            </p>

            {/* Submit and Close Buttons */}
            <div className="d-flex justify-content-between">
              <button
                onClick={handleSubmit}
                className="bg_darkblue1 border-0 rounded-2 fs_20 mt-3 fw-semibold text-white px-4 py-2"
              >
                Submit
              </button>
              <button
                onClick={closeModal}
                className="bg-danger border-0 rounded-2 fs_20 mt-3 fw-semibold text-white px-4 py-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EnterpriseNeedMoreInfo;
